import { render, staticRenderFns } from "./OECDeptSubHalfYear.vue?vue&type=template&id=d40a4d1a&scoped=true"
import script from "./OECDeptSubHalfYear.vue?vue&type=script&lang=js"
export * from "./OECDeptSubHalfYear.vue?vue&type=script&lang=js"
import style0 from "./OECDeptSubHalfYear.vue?vue&type=style&index=0&id=d40a4d1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d40a4d1a",
  null
  
)

export default component.exports